export default __webpack_public_path__ + "static/media/folder-plus.8649ec15.svg";